import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from "src/environments/environment";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { IApiBase } from "./Interface/IApiBase.interface";

@Injectable({
  providedIn: "root",
})
export class AlarmAPIService implements IApiBase {
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
    this.estatus = new EstatusJSON();
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }

  getById(id): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Alarms/GetAlarmResponseById?Id="+id, {});
  }

  getImportantAlarmsPage(page): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Alarms/GetImportantAlarmsPage?page="+page, {});
  }

  DeactivateAlarms(idAlarm): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Alarms/DeactivateAlarms?idAlarm="+idAlarm, {});
  }

  GetIdStatusActiveAlarms(): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Alarms/GetIdStatusActiveAlarms", {});
  }

  delete(UserId): any{
    console.log("no hay delete");
  }

  
  //paginacion
  getFilterValues(request : FilterRequest[]) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Alarms/GetFilterValues", request);
  }

  getPage(request : CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Alarms/GetPage", request);
  }
  getCount(request : CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Alarms/GetFilteredCount", request);
  }
  
}
